export enum EntityFormSectionType {
    Fields = 'fields',
    Relation = 'relation',
    Custom = 'custom',
    Spacer = 'spacer',
}
